import { faDot } from '@awesome.me/kit-4a6bf60416/icons/classic/solid';

import { Badge } from '@/components/ui/badge';
import { ContentContainer } from '@/components/ui/content-container';
import { Icon } from '@/components/ui/icon';
import { Heading2, Heading3, Paragraph } from '@/components/ui/typography';
import { formatProfileNames, normalizeProfiles } from '../../profile-list';
import type { CaseResultWidgetProps } from '../definition';

export function ListVariant({ title, caseResults }: CaseResultWidgetProps) {
  if (caseResults.length === 0) return null;

  return (
    <ContentContainer>
      <div className="mb-4 border-b border-border pb-4">
        <Heading2>{title}</Heading2>
      </div>

      <div className="flex flex-col gap-0">
        {caseResults.map((caseResult, index) => {
          const attorneys = normalizeProfiles(caseResult.attorneys);
          const attorneyLabel = formatProfileNames(attorneys);
          const courts = caseResult.courts ?? [];

          return (
            <article
              key={caseResult.id || index}
              className="group/case-item flex gap-6 border-b border-border py-8 last:border-b-0"
            >
              <div className="flex-1">
                {caseResult.title && (
                  <Heading3 className="mb-3 text-xl group-hover/case-item:text-primary transition-colors">
                    {caseResult.title}
                  </Heading3>
                )}
                {caseResult.summary && (
                  <Paragraph className="mb-4 text-muted-foreground line-clamp-2 leading-tight">
                    {caseResult.summary}
                  </Paragraph>
                )}
                <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
                  {courts.map((court) => (
                    <Badge
                      key={court.id}
                      variant="outline"
                      colorScheme="secondary"
                      className="border-input"
                    >
                      {court.name}
                    </Badge>
                  ))}
                  {caseResult.practiceAreas &&
                    caseResult.practiceAreas.length > 0 &&
                    caseResult.practiceAreas.map((area) => (
                      <Badge key={area.id || area.name} variant="outline" colorScheme="primary">
                        {area.name}
                      </Badge>
                    ))}
                  {attorneyLabel && (
                    <>
                      {courts.length > 0 && <Icon icon={faDot} className="text-muted-foreground" />}
                      <span className="font-medium">{attorneyLabel}</span>
                    </>
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </ContentContainer>
  );
}
